import pluralize from "pluralize"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { JobCountBadgeProps } from "./JobCountBadge.types"

const icon = faIcon({ name: "wrench-simple", style: "regular" })

export default function JobCountBadge(props: JobCountBadgeProps) {
    const { count, noun = "job", pluralizeNoun = true, tooltip, size = "md" } = props

    const label = `${count} ${pluralizeNoun ? pluralize(noun, count) : noun}`

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip ?? label}>
            {label}
        </Badge>
    )
}
